/**
 * Leaving for a new version (bugs.md): an unsent message turned the update's reloads into the browser's
 * own "Leave this page?" over and over, which nothing in the app could answer, and the app couldn't be
 * closed. An update the member chose is no discard: the guards stand aside for it (lib/dirty.tsx), and
 * what was typed is kept for the new version to put back.
 */
let leaving = false

/** Called right before an update reloads the page. */
export function leaveForUpdate() {
  leaving = true
}

export const leavingForUpdate = () => leaving

const KEY = 'fm-kept-draft:'

/** Keep a draft (a chat's unsent words) through the reload; this tab only. */
export function keepDraft(where: string, text: string) {
  try {
    if (text.trim()) sessionStorage.setItem(KEY + where, text)
  } catch {}
}

/** A kept draft, once: it's gone after this. */
export function takeDraft(where: string): string | null {
  try {
    const v = sessionStorage.getItem(KEY + where)
    if (v !== null) sessionStorage.removeItem(KEY + where)
    return v
  } catch {
    return null
  }
}
